import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getTestById, deleteTest } from "../../services/api"; // Asegúrate de tener estas funciones en tu API

const TestDelete = () => {
  const { projectId, testId } = useParams();
  const navigate = useNavigate();
  const [testData, setTestData] = useState(null);

  useEffect(() => {
    const fetchTest = async () => {
      try {
        const response = await getTestById(projectId, testId);
        setTestData(response);
      } catch (error) {
        console.error("Error al obtener el caso de prueba", error);
      }
    };

    fetchTest();
  }, [projectId, testId]);

  const handleDelete = async () => {
    try {
      await deleteTest(testId);
      navigate(`/projects/${projectId}/tests`);
    } catch (error) {
      console.error("Error al eliminar el caso de prueba", error);
    }
  };

  if (!testData) {
    return <div>Cargando...</div>;
  }

  return (
    <>
      <h2>Eliminar Caso de Prueba</h2>
      <p>
        ¿Estás seguro de que deseas eliminar el caso de prueba{" "}
        <strong>{testData.nombre}</strong>?
      </p>
      <button onClick={handleDelete} className="btn btn-danger">
        Eliminar
      </button>
      <button
        onClick={() => navigate(`/projects/${projectId}/tests`)}
        className="btn btn-secondary ml-2"
      >
        Cancelar
      </button>
    </>
  );
};

export default TestDelete;
